import script from "./PolicyReviewCriteriaCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyReviewCriteriaCard.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyReviewCriteriaCard.vue?vue&type=style&index=0&id=cefefe96&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cefefe96"]])

export default __exports__